// extracted by mini-css-extract-plugin
module.exports = {"shadow":"AnalyticsActions_shadow__2AvnS"};